import { render, staticRenderFns } from "./BillingCatalogDetail.vue?vue&type=template&id=6e2b2e12&scoped=true&"
import script from "./BillingCatalogDetail.vue?vue&type=script&lang=ts&"
export * from "./BillingCatalogDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BillingCatalogDetail.vue?vue&type=style&index=0&id=6e2b2e12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2b2e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSelect,VSpacer})
